export default "__VITE_ASSET__D5W$02dG__"